import React from 'react'

export function MiniFilter() {
  return (
    <div className="mini-search-bar">
      <div
        className="mini-search-bar__segments"
        role="group"
        aria-label="Search summary"
      >
        <button type="button" className="search-option">
          Anywhere
        </button>
        <div className="mini-search-bar__when">
          <span className="divider" aria-hidden />
          <button type="button" className="search-option">
            Any week
          </button>
          <span className="divider" aria-hidden />
        </div>
        <button type="button" className="search-option guests">
          Add guests
        </button>
      </div>
      <button type="button" className="search-button" aria-label="Search">
        <svg
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          role="presentation"
          focusable="false"
          style={{
            display: 'block',
            fill: 'none',
            height: '12px',
            width: '12px',
            stroke: 'currentcolor',
            strokeWidth: '5.33333',
            overflow: 'visible',
          }}
        >
          <g fill="none">
            <path d="m13 24c6.0751322 0 11-4.9248678 11-11 0-6.07513225-4.9248678-11-11-11-6.07513225 0-11 4.92486775-11 11 0 6.0751322 4.92486775 11 11 11zm8-3 9 9" />
          </g>
        </svg>
      </button>
    </div>
  )
}
